<template>
  <div class="slide">
    <div class="wrapper">
      <div class="wrapper__left">
        <div v-if="slide.icon"
             class="slide__icon">
          <img :src="slide.icon" :alt="slide.title"/>
        </div>
        <div class="slide__info">
          <h5 v-if="slide.pretitle"
              class="slide__pretitle">{{slide.pretitle}}</h5>
          <h3 v-if="slide.title"
              class="slide__title">{{slide.title}}</h3>
          <h4 v-if="slide.subtitle"
              class="slide__subtitle">{{slide.subtitle}}</h4>
        </div>
        <div v-if="slide.image && !slide.imageAfterText"
             class="slide__image">
          <img :src="slide.image" alt=""/>
        </div>
      </div>

      <div class="wrapper__right">
        <p v-if="slide.content"
           class="slide__content"
           v-html="slide.content"></p>
        <div v-if="slide.image && slide.imageAfterText"
             class="slide__image">
          <img :src="slide.image" alt=""/>
        </div>
        <ul v-if="slide.list"
            class="slide__list">
          <li v-for="item in slide.list"
              class="slide__list__item">
            <img v-if="item.icon" :src="item.icon" alt=""/>
            <span v-if="item.label" v-html="item.label"></span>
          </li>
        </ul>
        <a v-if="slide.download" class="slide__download" target="_blank" :href="slide.download.path">{{slide.download.label}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    props: ['config'],
    data(){
      return {
        slide: this.config
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/info/Slide.vue